<template>
  <footer class="footer" :class="'footer-'+theme">
    <div
      class="container-fluid d-flex flex-wrap justify-content-between"
      :class="'container-fluid-'+theme"
    >
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright" :class="'footer-'+theme">
        &copy; Ever Investor 2021. Feito com
        <i class="fa fa-heart heart"></i> pela equipe dEvI.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>
<style>
.footer-black {
  background: #0b0c0d !important;
  color: #d8d8d8 !important;
}
.footer-light {
  background: #d8d8d8 !important;
  color: #03141e !important;
}
.container-fluid-black {
  background: #0b0c0d !important;
  color: #d8d8d8 !important;
}
.container-fluid-light {
  background: #d8d8d8 !important;
  color: #03141e !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/ContentFooter.vue